import loadable from '@loadable/component';

export const LaptopmagSiteWrapper = loadable(
  () => import(/* webpackChunkName: "laptopmag-site" */ './LaptopmagSiteWrapper'),
);
